module.exports = __webpack_public_path__ + "img/canada-liver-cancer-male.834233c7.png";